import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { KATEGORI } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";

export const emptyDetail = () => ({
  key: Math.random().toString(36).slice(2),
  deskripsi: "",
  jenis_order: "",
  kategori: "",
  panjang: "",
  lebar: "",
  qty: "1",
});

const cell = "h-10 bg-slate-900/70 border-white/10 text-sm";

export const OrderDetailTable = ({ rows, onChange }) => {
  const update = (key, field, value) =>
    onChange(rows.map((r) => (r.key === key ? { ...r, [field]: value } : r)));

  const addRow = () => onChange([...rows, emptyDetail()]);
  const removeRow = (key) =>
    onChange(rows.length === 1 ? [emptyDetail()] : rows.filter((r) => r.key !== key));

  return (
    <div data-testid="jo-detail-table">
      <div className="overflow-x-auto rounded-xl border border-white/10 bg-slate-950/60">
        <table className="w-full min-w-[900px] text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-[0.16em] text-slate-400">
              <th className="px-3 py-3 font-semibold w-[26%]">Deskripsi</th>
              <th className="px-3 py-3 font-semibold w-[18%]">Jenis Order</th>
              <th className="px-3 py-3 font-semibold w-[18%]">Kategori</th>
              <th className="px-3 py-3 font-semibold w-[11%]">Ukuran (P)</th>
              <th className="px-3 py-3 font-semibold w-[11%]">Ukuran (L)</th>
              <th className="px-3 py-3 font-semibold w-[10%]">Qty</th>
              <th className="px-3 py-3" />
            </tr>
          </thead>
          <tbody>
            {rows.map((r, idx) => (
              <tr key={r.key} className="border-t border-white/5" data-testid={`jo-detail-row-${idx}`}>
                <td className="px-3 py-2.5">
                  <Input
                    data-testid={`jo-detail-deskripsi-${idx}`}
                    placeholder="Banner flexi china"
                    value={r.deskripsi}
                    onChange={(e) => update(r.key, "deskripsi", e.target.value)}
                    className={cell}
                  />
                </td>
                <td className="px-3 py-2.5">
                  <Input
                    data-testid={`jo-detail-jenis-${idx}`}
                    placeholder="Cetak / Pasang"
                    value={r.jenis_order}
                    onChange={(e) => update(r.key, "jenis_order", e.target.value)}
                    className={cell}
                  />
                </td>
                <td className="px-3 py-2.5">
                  <select
                    data-testid={`jo-detail-kategori-${idx}`}
                    value={r.kategori}
                    onChange={(e) => update(r.key, "kategori", e.target.value)}
                    className="h-10 w-full rounded-md bg-slate-900/70 border border-white/10 px-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Pilih kategori</option>
                    {KATEGORI.map((k) => (
                      <option key={k} value={k}>{k}</option>
                    ))}
                  </select>
                </td>
                <td className="px-3 py-2.5">
                  <Input
                    data-testid={`jo-detail-panjang-${idx}`}
                    placeholder="3"
                    value={r.panjang}
                    onChange={(e) => update(r.key, "panjang", e.target.value)}
                    className={cell}
                  />
                </td>
                <td className="px-3 py-2.5">
                  <Input
                    data-testid={`jo-detail-lebar-${idx}`}
                    placeholder="1"
                    value={r.lebar}
                    onChange={(e) => update(r.key, "lebar", e.target.value)}
                    className={cell}
                  />
                </td>
                <td className="px-3 py-2.5">
                  <Input
                    data-testid={`jo-detail-qty-${idx}`}
                    placeholder="1"
                    value={r.qty}
                    onChange={(e) => update(r.key, "qty", e.target.value)}
                    className={cell}
                  />
                </td>
                <td className="px-3 py-2.5 text-right">
                  <button
                    type="button"
                    data-testid={`jo-detail-remove-${idx}`}
                    onClick={() => removeRow(r.key)}
                    title="Hapus baris"
                    className="text-red-300 hover:text-red-200 transition-colors duration-200"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        data-testid="jo-detail-add-row"
        onClick={addRow}
        className="mt-3 inline-flex items-center gap-1.5 rounded-lg border border-blue-400/30 bg-blue-500/10 px-3 py-2 text-[11px] font-semibold uppercase tracking-wider text-blue-200 hover:bg-blue-500/20 transition-colors duration-200"
      >
        <Plus className="w-3.5 h-3.5" /> Tambah baris order
      </button>
    </div>
  );
};
